import React from "react";
import styles from "../../styles/layout/DashboardHeaderBtm.module.scss";
import { Box, Button, List, ListItem, Typography } from "@mui/material";
import arrow from "../../assets/left-chevron.png";
import { useNavigate } from "react-router-dom";
export default function DashBoardHeaderBtm({ showList ,customerID,customerSince,marketingStatus,lastLogIn}) {
  const navigate = useNavigate()
  const backToPrevPage =()=>{
    navigate(-1)
  }
  return (
    <Box className={styles.dashHeaderBtm}>
        
      <Button className={styles.back_btn} onClick={backToPrevPage}>
        <img src={arrow} alt="" />
        <Typography variant="body1">Back</Typography>
      </Button>
      {showList && (
        <List disablePadding>
          <ListItem disablePadding>
            <Typography variant="body1">
              Customer Id:<strong>{customerID}</strong>
            </Typography>
          </ListItem>
          <ListItem disablePadding>
            <Typography variant="body1">
              Customer Since:<strong>{customerSince}</strong>
            </Typography>
          </ListItem>
          <ListItem disablePadding>
            <Typography variant="body1">
              Marketing Status:<strong>{marketingStatus}</strong>
            </Typography>
          </ListItem>
          <ListItem disablePadding>
            <Typography variant="body1">
              Last Login:<strong>{lastLogIn}</strong>
            </Typography>
          </ListItem>
        </List>
      )}
    </Box>
  );
}
